import { SkinCard } from './SkinCard';
import { SkinCardErrorBoundary } from './SkinCardErrorBoundary';
import type { MarketItem } from '@/lib/api';

interface SkinGridProps {
  skins: MarketItem[];
  viewMode?: 'grid' | 'list';
}

export function SkinGrid({ skins, viewMode = 'grid' }: SkinGridProps) {
  if (skins.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-[#8b949e] text-lg">Ничего не найдено</p>
        <p className="text-[#6e7681] text-sm mt-2">Попробуйте изменить параметры поиска</p>
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <div className="space-y-3">
        {skins.map((skin) => (
          <SkinCardErrorBoundary key={skin.id}>
            <SkinCard skin={skin} viewMode="list" />
          </SkinCardErrorBoundary>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
      {skins.map((skin) => (
        <SkinCardErrorBoundary key={skin.id}>
          <SkinCard skin={skin} />
        </SkinCardErrorBoundary>
      ))}
    </div>
  );
}
